import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';

function LandingPage(props) {
    const { tenantInfo, version } = props;
    return (
        <AuthWrapper heading="Welcome back!">
            {tenantInfo && version && (
                <section className="sten-content__section">
                    <h2 className="text-center">{`${tenantInfo.value.name} identity(${version}) site`}</h2>
                </section>
            )}
            <section className="sten-content__section">
                <h3 className="text-center">
                    <span>IdentityServer publishes a </span>
                    <a href="/.well-known/openid-configuration">discovery document</a>
                    <span> where you can find metadata and links to all the endpoints, key material, etc.</span>
                </h3>
            </section>
            <section className="sten-content__section">
                <a className="btn btn--primary col-24" href="/account/login">Login</a>
            </section>
        </AuthWrapper>
    );
}

LandingPage.propTypes = {
    tenantInfo: PropTypes.objectOf(PropTypes.any),
    version: PropTypes.string
};

LandingPage.defaultProps = {
    tenantInfo: null,
    version: ''
};

export default LandingPage;
